var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="margin-bottom-ms-1">На указанный вами e-mail отправлен код подтверждения.</p> <p class="margin-bottom-0">Просьба ввести его в поле и нажать Далее.</p>';
}
return __p;
};
